import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useResetPassword} from '../../hooks/useResetPassword';
import ForgotPassword from '../../services/Frogot.api.service';
import NewPasswordFrom from './NewPasswordFrom';
import PageLayout from '../../components/PageLayout';
import {Link} from 'react-router-dom';
import {Button} from 'antd';
import {useTranslation} from 'react-i18next';

const pageInfo = {
  default: {
    title: 'recovery.newTitle'
  },
  sent: {
    title: 'recovery.newTitle',
    subtext: 'recovery.newSentSubtext',
  },

  error: {
    title: 'recovery.errorCheckTitle',
    titleProps: {className: 'text-error'},
    subtext: 'recovery.errorCheckSubtext',
  }
};

function NewPassword(props) {
  const {t} = useTranslation('authentication');
  const [loading, setLoading] = useState(true);
  const [errorCheck, setCheckError] = useState(false);
  const {error, data, isLoading, onFinish} = useResetPassword();

  useEffect(() => {
    ForgotPassword.check({type: 'email', key: props.match.params.key}).then(() => {
      setLoading(false);
      setCheckError(false);
    }).catch(() => {
      setLoading(false);
      setCheckError(true);
    });
  }, [props.match.params.key]);

  const handleSubmit = useCallback(async (formData) => {
    await onFinish({...formData, key: props.match.params.key});
  }, [onFinish, props.match.params.key]);


  let pageProps = errorCheck ? pageInfo.error : pageInfo.default;
  let content = <NewPasswordFrom handleSubmit={handleSubmit} loading={loading || isLoading}
    hasError={errorCheck}/>;

  const sent = data && !error;
  if (sent) {
    content = '';
    pageProps = pageInfo.sent;
  }


  return (

    <PageLayout {...pageProps} error={error}>
      {content}
      {sent &&
        <div>
          <Link to={'/'}>
            <Button size={'large'} type={'primary'} className={'w-full'}>
              {t('letsStart')}
            </Button>
          </Link>
        </div>}
    </PageLayout>
  );
}

export default NewPassword;

NewPassword.propTypes = {
  match: PropTypes.any
};
